// extracted by mini-css-extract-plugin
export default {"form":"styles_form__EyD6T","input":"styles_input__bv5ar","photoContainer":"styles_photoContainer__7gKMG","image":"styles_image__QIRJm"};